// import EntypoIcon from 'react-native-vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUISalePageSettingWebView from 'xui/modules/storeWebsite/BaseUISalePageSettingWebView'

export default class SalePageSettingWebView extends BaseUISalePageSettingWebView {}
